<div class="container pt-3 mt-5 mb-3">
    <div class="row justify-content-center">
        <p class="text-center">{{ 'byt_partners' | translate }}</p>
    </div>
</div>
<div class="container-fluid mb-5 pb-5" *ngIf="(item | async) as data; else loading">
    <div class="row mt-4 text-center">
        <div class="col-md mb-4 mb-md-0" *ngFor="let partner of data">
            <a [href]="partner.url" target="_blank"><img height="70px" width="70px" class="supporter" [defaultImage]="defaultImage"
                    [lazyLoad]="partner.image | getImageUrlDirectus" [alt]="partner.name"/></a>
        </div>
    </div>
</div>

<ng-template #loading>
    <div class="row vh-50 d-flex justify-content-center align-items-center">
        <div class="col-12">
            <app-spinner></app-spinner>
        </div>
    </div>
</ng-template>